import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  searchOpenings: {
    id: 'app.components.Openings.FilterableOpeningsTable.searchOpenings',
    defaultMessage: 'Search Openings',
  },
  active: {
    id: 'app.components.Openings.FilterableOpeningsTable.active',
    defaultMessage: 'Active',
  },
  inactive: {
    id: 'app.components.Openings.FilterableOpeningsTable.inactive',
    defaultMessage: 'Inactive',
  },
  anyStatus: {
    id: 'app.components.Openings.FilterableOpeningsTable.anyStatus',
    defaultMessage: 'Any status',
  },
  pendingApproval: {
    id: 'app.components.Openings.FilterableOpeningsTable.pendingApproval',
    defaultMessage: 'Pending Approval',
  },
  userOpenings: {
    id: 'app.components.Openings.FilterableOpeningsTable.userOpenings',
    defaultMessage: 'My Openings',
  },
  opening: {
    id: 'app.components.Openings.FilterableOpeningsTable.opening',
    defaultMessage: 'Opening',
  },
  brand: {
    id: 'app.components.Openings.FilterableOpeningsTable.brand',
    defaultMessage: 'Brand',
  },
  noBrandsAvailable: {
    id: 'app.components.Openings.FilterableOpeningsTable.noBrandsAvailable',
    defaultMessage: 'No brands available',
  },
  searchBrands: {
    id: 'app.components.Openings.FilterableOpeningsTable.searchBrands',
    defaultMessage: 'Search brands',
  },
  noBrandsMatchSearch: {
    id: 'app.components.Openings.FilterableOpeningsTable.noBrandsMatchSearch',
    defaultMessage: 'No brands match "{query}"',
  },
  locationGroup: {
    id: 'app.components.Openings.FilterableOpeningsTable.locationGroup',
    defaultMessage: 'Location Group',
  },
  locationAndAddress: {
    id: 'app.components.Openings.FilterableOpeningsTable.locationAndAddress',
    defaultMessage: 'Location & Address',
  },
  noLocationsAvailable: {
    id: 'app.components.Openings.FilterableOpeningsTable.noLocationsAvailable',
    defaultMessage: 'No locations available',
  },
  searchLocations: {
    id: 'app.components.Openings.FilterableOpeningsTable.searchLocations',
    defaultMessage: 'Search locations',
  },
  noLocationsMatchSearch: {
    id: 'app.components.Openings.FilterableOpeningsTable.noLocationsMatchSearch',
    defaultMessage: 'No locations match "{query}"',
  },
  pipeline: {
    id: 'app.components.Openings.FilterableOpeningsTable.pipeline',
    defaultMessage: 'Pipeline',
  },
  applications: {
    id: 'app.components.Openings.FilterableOpeningsTable.applications',
    defaultMessage: 'Applications',
  },
  totalApplicants: {
    id: 'app.components.Openings.FilterableOpeningsTable.totalApplicants',
    defaultMessage: 'Total applicants',
    description: 'Count of applicants to an opening across every status',
  },
  totalApplicantsTooltip: {
    id: 'app.components.Openings.FilterableOpeningsTable.totalApplicantsTooltip',
    defaultMessage:
      'All applicants in this opening in any stage, including On Hold, Hired, and Rejected.',
    description:
      'Definition of the total applicant count, including terminal stages',
  },
  hiringGoal: {
    id: 'app.components.Openings.FilterableOpeningsTable.hiringGoal',
    defaultMessage: 'Hiring Goal',
  },
  hiresNeeded: {
    id: 'app.components.Openings.FilterableOpeningsTable.hiresNeeded',
    defaultMessage: 'Hires Needed',
  },
  pipelineTooltip: {
    id: 'app.components.Openings.FilterableOpeningsTable.pipelineTooltip',
    defaultMessage:
      'Number of applications that are not marked as hired or currently in the On Hold, Hired, or Rejected stage.',
  },
  workflow: {
    id: 'app.components.Openings.FilterableOpeningsTable.workflow',
    defaultMessage: 'Workflow',
  },
  noWorkflowsAvailable: {
    id: 'app.components.Openings.FilterableOpeningsTable.noWorkflowsAvailable',
    defaultMessage: 'No workflows available',
  },
  searchWorkflows: {
    id: 'app.components.Openings.FilterableOpeningsTable.searchWorkflows',
    defaultMessage: 'Search workflows',
  },
  noWorkflowsMatchSearch: {
    id: 'app.components.Openings.FilterableOpeningsTable.noWorkflowsMatchSearch',
    defaultMessage: 'No workflows match "{query}"',
  },
  hireGo: {
    id: 'app.components.Openings.FilterableOpeningsTable.hireGo',
    defaultMessage: 'Hire Go',
  },
  hireGoTooltip: {
    id: 'app.components.Openings.FilterableOpeningsTable.hireGoTooltip',
    defaultMessage:
      'Indicates the opening is being managed by users in Hire Go',
  },
  availableTalent: {
    id: 'app.components.Openings.FilterableOpeningsTable.availableTalent',
    defaultMessage: 'Available Pool talent',
  },
  availableTalentTooltip: {
    id: 'app.components.Openings.FilterableOpeningsTable.availableTalentTooltip',
    defaultMessage: 'Updated hourly',
    description:
      'Tooltip on the Available Pool talent column header. The count is recomputed in the background every hour.',
  },
  owner: {
    id: 'app.components.Openings.FilterableOpeningsTable.owner',
    defaultMessage: 'Owner',
  },
  noOwnersAvailable: {
    id: 'app.components.Openings.FilterableOpeningsTable.noOwnersAvailable',
    defaultMessage: 'No owners available',
  },
  searchOwners: {
    id: 'app.components.Openings.FilterableOpeningsTable.searchOwners',
    defaultMessage: 'Search owners',
  },
  noOwnersMatchSearch: {
    id: 'app.components.Openings.FilterableOpeningsTable.noOwnersMatchSearch',
    defaultMessage: 'No owners match "{query}"',
  },
  creationDate: {
    id: 'app.components.Openings.FilterableOpeningsTable.creationDate',
    defaultMessage: 'Creation Date',
  },
  pay: {
    id: 'app.components.Openings.FilterableOpeningsTable.pay',
    defaultMessage: 'Pay',
  },
  customizeColumns: {
    id: 'app.components.Openings.FilterableOpeningsTable.customizeColumns',
    defaultMessage: 'Customize columns',
  },
  bulkSelectColumn: {
    id: 'app.components.Openings.FilterableOpeningsTable.bulkSelectColumn',
    defaultMessage: 'Select openings',
  },
  attributes: {
    id: 'app.components.Openings.FilterableOpeningsTable.attributes',
    defaultMessage: 'Attributes',
  },
  searchAttributes: {
    id: 'app.components.Openings.FilterableOpeningsTable.searchAttributes',
    defaultMessage: 'Search attributes',
  },
  noAttributesAvailable: {
    id: 'app.components.Openings.FilterableOpeningsTable.noAttributesAvailable',
    defaultMessage: 'No attributes available',
  },
  noAttributesMatchSearch: {
    id: 'app.components.Openings.FilterableOpeningsTable.noAttributesMatchSearch',
    defaultMessage: 'No attributes match "{query}"',
  },
  searchAttributeValues: {
    id: 'app.components.Openings.FilterableOpeningsTable.searchAttributeValues',
    defaultMessage: 'Search {label}',
  },
  missingAttributeValue: {
    id: 'app.components.Openings.FilterableOpeningsTable.missingAttributeValue',
    defaultMessage: 'Missing {label}',
  },
  noAttributeValuesAvailable: {
    id: 'app.components.Openings.FilterableOpeningsTable.noAttributeValuesAvailable',
    defaultMessage: 'No values available',
  },
  noAttributeValuesMatchSearch: {
    id: 'app.components.Openings.FilterableOpeningsTable.noAttributeValuesMatchSearch',
    defaultMessage: 'No values match "{query}"',
  },
  // Shared by the Attributes filter's own "clear all sub-filters" footer
  // button and the page-level "clear every filter" button - keep the
  // wording as a single source so the two can never drift apart. The `id`
  // predates the page-level button (from the Attributes filter) and stays
  // as-is to avoid orphaning its existing translations.
  clearAll: {
    id: 'app.components.Openings.FilterableOpeningsTable.clearAllAttributeFilters',
    defaultMessage: 'Clear all',
  },
  saveView: {
    id: 'app.components.Openings.FilterableOpeningsTable.saveView',
    defaultMessage: 'Save filter set as view',
  },
  views: {
    id: 'app.components.Openings.FilterableOpeningsTable.views',
    defaultMessage: 'Views',
  },
  saveViewNamePlaceholder: {
    id: 'app.components.Openings.FilterableOpeningsTable.saveViewNamePlaceholder',
    defaultMessage: 'View name',
  },
  savedViewCreateSuccess: {
    id: 'app.components.Openings.FilterableOpeningsTable.savedViewCreateSuccess',
    defaultMessage: 'View saved',
  },
  // Matches the backend's uniqueness-validation message verbatim (Rails'
  // default humanized "has already been taken" wording) so the error reads
  // identically whether it was caught client-side or came back from the 422.
  saveViewDuplicateTitleError: {
    id: 'app.components.Openings.FilterableOpeningsTable.saveViewDuplicateTitleError',
    defaultMessage: 'Title has already been taken',
  },
  savedViewSaveError: {
    id: 'app.components.Openings.FilterableOpeningsTable.savedViewSaveError',
    defaultMessage: "We couldn't save your view. Please try again.",
  },
  savedViewApplyError: {
    id: 'app.components.Openings.FilterableOpeningsTable.savedViewApplyError',
    defaultMessage: "We couldn't apply that view. Please try again.",
  },
  updateView: {
    id: 'app.components.Openings.FilterableOpeningsTable.updateView',
    defaultMessage: 'Update view',
  },
  saveNewView: {
    id: 'app.components.Openings.FilterableOpeningsTable.saveNewView',
    defaultMessage: 'Save new view',
  },
  savedViewUpdateSuccess: {
    id: 'app.components.Openings.FilterableOpeningsTable.savedViewUpdateSuccess',
    defaultMessage: 'View updated',
  },
  savedViewUpdateError: {
    id: 'app.components.Openings.FilterableOpeningsTable.savedViewUpdateError',
    defaultMessage: "We couldn't update your view. Please try again.",
  },
  deleteSavedViewButtonLabel: {
    id: 'app.components.Openings.FilterableOpeningsTable.deleteSavedViewButtonLabel',
    defaultMessage: 'Delete {title}',
  },
  deleteSavedViewTitle: {
    id: 'app.components.Openings.FilterableOpeningsTable.deleteSavedViewTitle',
    defaultMessage: 'Delete filtered view',
  },
  deleteSavedViewConfirmation: {
    id: 'app.components.Openings.FilterableOpeningsTable.deleteSavedViewConfirmation',
    defaultMessage:
      'Are you sure you want to delete the filtered view “{title}”?',
  },
  savedViewDeleteSuccess: {
    id: 'app.components.Openings.FilterableOpeningsTable.savedViewDeleteSuccess',
    defaultMessage: 'View deleted',
  },
  savedViewDeleteError: {
    id: 'app.components.Openings.FilterableOpeningsTable.savedViewDeleteError',
    defaultMessage: "We couldn't delete your view. Please try again.",
  },
});
